import { ComposerPrimitive } from '@assistant-ui/react';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

import classes from './Composer.module.css';
import { ComposerAction } from './ComposerAction.tsx';

/** Chat message composer with auto-resizing textarea and send/cancel actions. */
export function Composer() {
  const { t } = useTranslation('chat');
  // Create motion-enabled version of ComposerPrimitive.Root to support CSS transitions on mount/unmount
  const Root = motion.create(ComposerPrimitive.Root);
  return (
    <Root className={classes.composer}>
      <div className={classes.inputContainer}>
        <ComposerPrimitive.Input
          aria-label={t('messageInput')}
          autoFocus
          className={classes.inputTextarea}
          maxRows={5}
          placeholder={t('sendMessage')}
          rows={1}
        />
        <ComposerAction />
      </div>
    </Root>
  );
}
